// Shared helper to derive a safe API base URL.
// Defaults to same-origin "/api" so production can rely on the web server proxy.

export function normalizeApiBaseUrl(raw) {
  let value = (raw ?? '').toString().trim();

  // CRA env values are sometimes set like: REACT_APP_API_URL='https://.../api';
  // Strip surrounding quotes and a trailing semicolon if present.
  if (
    (value.startsWith("'") && value.endsWith("'")) ||
    (value.startsWith('"') && value.endsWith('"'))
  ) {
    value = value.slice(1, -1);
  }

  value = value.trim().replace(/;$/, '').trim();

  // Remove trailing slashes so `${base}/path` composes predictably.
  value = value.replace(/\/+$/, '');

  return value || '/api';
}

export function getApiBaseUrl() {
  return normalizeApiBaseUrl(process.env.REACT_APP_API_URL);
}

